import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'
// import { useApi } from '../utils/useApi'; // auto-refreshing fetch wrapper
import { dedupedRequest } from '../utils/axios';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';


const ClientSelection = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  // const { apiFetch } = useApi();
  const { isAuthenticated, user } = auth;

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState<any[]>([]);

  useEffect(() => {
    if (isAuthenticated && user && (user.role === "lawyer" || user.role === "superadmin")) {
      loadClients();
    }
  }, []);

  const loadClients = async () => {
    dedupedRequest({ method: 'GET', url: '/admin/clients' }, { useCache: false })
      .then(res => setClients(res.data))
      .catch(err => console.error("Failed to load clients", err));
  };

  const setClient = async (clientId: number) => {
    if (loading) return; // Prevent multiple submissions
    setLoading(true);
    setError('');
    try {
      const response = await dedupedRequest({ method: 'POST', url: '/admin/tempclient', data: { clientId } }, { useCache: false });
      // console.log('Client selection response:', response.data);
      // console.log('Updated user from backend:', response.data.user);
      auth.setUser(response.data.user);
      navigate('/vorschriften');
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.detail ||
        err?.message ||
        'Kundenwahl fehlgeschlagen';
      setError(msg);
    } finally {
      setLoading(false);
    }
  }
  
  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md="auto">
          <Card style={{ width: '24rem' }}>
            <Card.Body>
              <Card.Title><h2>Kunde auswählen</h2></Card.Title>
                <div className="mb-3">
                  <div className="mb-3">
                    <p>Kunde auswählen:</p>
                    <DropdownButton id="dropdown-item-button" title="Kundenliste">
                      {clients.map(c => (
                        <Dropdown.Item key={c.id} onClick={() => setClient(c.id)}>
                          {c.name}
                        </Dropdown.Item>
                      ))}
                    </DropdownButton>
                  </div>
                </div>
                {error && <p style={{ color: 'red' }}>{error}</p>}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ClientSelection;

